"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaymentError = void 0;
var StripeErrors_1 = require("../Enums/StripeErrors");
var getPaymentError = function (item) {
    var _a, _b, _c;
    var orderItem = item;
    var stripeError = item;
    var errorCode = ((_a = orderItem.stripePayment) === null || _a === void 0 ? void 0 : _a.errorCode) || (stripeError === null || stripeError === void 0 ? void 0 : stripeError.code);
    var declineCode = ((_b = orderItem.stripePayment) === null || _b === void 0 ? void 0 : _b.declineCode) || (stripeError === null || stripeError === void 0 ? void 0 : stripeError.decline_code);
    var neededAction = (_c = orderItem.stripePayment) === null || _c === void 0 ? void 0 : _c.neededAction;
    var mappedMessage = StripeErrors_1.StripeErrorMessages.generic_decline;
    if (declineCode && StripeErrors_1.StripeErrorMessages[declineCode]) {
        mappedMessage = StripeErrors_1.StripeErrorMessages[declineCode];
    }
    if (errorCode && StripeErrors_1.StripeErrorMessages[errorCode]) {
        mappedMessage = StripeErrors_1.StripeErrorMessages[errorCode];
    }
    if (neededAction === '3ds' || neededAction === 'front_validation') {
        mappedMessage = StripeErrors_1.StripeErrorMessages.authentication_required;
    }
    if (orderItem.stripePayment && !orderItem.stripePayment.currentStripePayment) {
        mappedMessage = StripeErrors_1.StripeErrorMessages.call_issuer;
    }
    return mappedMessage;
};
exports.getPaymentError = getPaymentError;
exports.default = { getPaymentError: exports.getPaymentError };
//# sourceMappingURL=PaymentErrors.js.map